<template>
  <el-menu :collapse="isExpand" id="Sidebar" background-color="#01b983" text-color="#fff" active-text-color="#ffd04b" :default-active="$route.path" :unique-opened="false" router >

    <el-menu-item index="/landingPage" >
      <i class="el-icon-document" style="color:#fff"></i>
      <span slot="title">首页</span>
    </el-menu-item>
    <!-- index="/boothBook" -->
    <el-menu-item  @click="navToLink" v-if="userInfo.bthCode && this.isshowBooth === '1'" >
      <div style="background:#f77c0f;border-radius:16px;margin-left:-16px;padding-left:16px">
        <i class="el-icon-date" style="color:#fff;"></i>
        <span slot="title" style="color:#fff;font-weight:bold">2026年展位预订</span>
      </div>
    </el-menu-item>

    <!-- <el-menu-item  @click="navToLink" >
      <i class="el-icon-date" style="color:#fff"></i>
      <span slot="title">2025年展位预订</span>
    </el-menu-item> -->
    
    <el-submenu  index='1'>
      <template slot="title">
        <i class="el-icon-s-marketing" style="color:#fff"></i>
        <span>公司信息</span>
      </template>
      <el-menu-item index="/magezine">会刊信息</el-menu-item>
      <el-menu-item index="/product">主要产品</el-menu-item>
      <!-- <el-menu-item index="/addProduct">展品上传</el-menu-item> -->
      <el-menu-item index="/productList">产品图片上传</el-menu-item>
    </el-submenu>
    <el-menu-item index="/card">
      <i class="el-icon-document" style="color:#fff"></i>
      <span slot="title">参展证申请</span>
    </el-menu-item>
    <el-menu-item index="/inviteCode">
      <i class="el-icon-postcard" style="color:#fff"></i>
      <span slot="title">企业名片</span>
    </el-menu-item>
    <el-submenu index='2'>
      <template slot="title"   >
        <div @click="navTozw">
          <i class="el-icon-s-ticket" style="color:#fff"></i>
         <span>我的展位</span>
        </div>
      </template>
      <el-menu-item index="/boardInfo"  >标准展位</el-menu-item>
      <el-menu-item index="/tz">特装展位</el-menu-item>
    </el-submenu>
    <el-menu-item index="/activityList"  >
      <i class="el-icon-date" style="color:#fff"></i>
      <span slot="title">同期会议</span>
    </el-menu-item>
    <el-submenu index='3'>
      <template slot="title">
        <i class="el-icon-s-ticket" style="color:#fff"></i>
        <span>营销服务</span>
      </template>
      <el-menu-item index="/adBook" >CAC整合营销手册</el-menu-item>  
      <el-menu-item index="/fshow"><!-- FSHOW赞助方案 -->FSHOW宣传方案</el-menu-item>   
    </el-submenu>
    <!-- <el-menu-item index="/lzCode">
      <i class="el-icon-document" style="color:#fff"></i>
      <span slot="title">自助领证码</span>
    </el-menu-item> -->
    <el-menu-item index="/hotel" >
      <i class="el-icon-date" style="color:#fff"></i>
      <span slot="title">酒店预订</span>
    </el-menu-item>
    <el-menu-item index="/yaoqing" >
      <i class="el-icon-collection" style="color:#fff"></i>
      <span slot="title">邀请函</span>
    </el-menu-item>
    <el-menu-item index="/downCenter" >
      <i class="el-icon-download" style="color:#fff"></i>
      <span slot="title">下载中心</span>
    </el-menu-item>
    <!-- <el-menu-item index="/boothBook" >
      <i class="el-icon-date" style="color:#fff"></i>
      <span slot="title">下届展位预定</span>
    </el-menu-item> -->
  </el-menu>
</template>

<script>
import api from '@/api'
export default {
  data() {
    return {
      // currentMenuIndex: this.$route.meta.menuIndex.toString(),
      userInfo: {},
      isShowCode:false,
      mainFunList:{},
      companyMuenList: {},
      ztMuenList: {},
      xkMuenList: {},
      atyMuenList: {},
      lzmMuenList: {},
      cooperaMuenList: {},
      typeStr:"",
      iframeUrl:"",
      isshowBooth: sessionStorage.getItem('isshowBooth')
    }
  },
  created() {
    this.initDashboard()
  },

  mounted() {
    // console.log(this.isshowBooth, '109')
    this.getmenulist()
    if (this.isshowBooth === '1' && this.userInfo.bthCode) {
      this.getUrl()
    }
  },

  watch: {},
  computed: {
    isExpand() {
      return this.$store.state.status.isExpand
    },
    // 控制显示的菜单
    isShowMenu() {
      return function(_arr,str) {
        var _arrList = this[_arr]
        if(_arrList.childs){
          for(var i = 0; i<_arrList.childs.length;i++){
              if( _arrList.childs[i].perName == str){
                return true
              }
          }
          return false
        }else{
          return false
        }
      }
    }
  },
  methods: {
    getUrl(){
      api.getdynamicboothmapurl({
        source:"下届",  //下届    本届
        language:"cn"
      }).then(res=>{
        // console.log(res.data)
        if(res.data.code == '200'){
            this.iframeUrl = res.data.data.dynamicUrl || ''
            // console.log('dddddddddddddd')
        }
      })
    },
    getmenulist() {
      api.getmenulist().then(res => {
        if (res.data.code === 200) {
          var menulist = res.data.data
          for(var i=0;i<menulist.length;i++){
            if(menulist[i].perName == '主要功能'){
              this.mainFunList = menulist[i]
            }
            if(menulist[i].perName == '公司信息'){
              this.companyMuenList = menulist[i]
            }
            if(menulist[i].perName == '我的展台'){
              this.ztMuenList = menulist[i]
            }
            if(menulist[i].perName == '胸卡申请'){
              this.xkMuenList = menulist[i]
            }
            if(menulist[i].perName == '自助领证码'){
              this.lzmMuenList = menulist[i]
            }
            if(menulist[i].perName == '活动列表'){
              this.atyMuenList = menulist[i]
            }
            if(menulist[i].perName == '合作服务'){
              this.cooperaMuenList = menulist[i]
            }
          }
        }
      })
    },
    navTozw(){
      if(this.userInfo.bthBigType=='SS'){
          this.$router.push({path:'/boardInfo'})
          // window.location.href = 'https://serv.exporegist.com/nyZfw/#/boardInfo'
        }else{
          this.$router.push({path:'/tz'})
          // window.location.href = 'https://serv.exporegist.com/nyZfw/#/tz'
        }
    },
    navTo(name) {
      if (this.$route.name === name) {
        return false
      }
      this.$router.push(`/${name}`)
    },
    navToLink(link){
      // console.log('eeeeeeeeeeee')
      window.open(this.iframeUrl, '_blank');
      // window.location.href = link,'_blank'
    },
    initDashboard() {
      this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
      // this.userInfo.bthCode='1'
      let duration = ''

      if (!this.userInfo) {
        this.$router.push('/login?ExhID='+localStorage.getItem("ExhID"))
        return
      }

      if (this.userInfo.loginTime === '') {
        this.$router.push('/login?ExhID='+localStorage.getItem("ExhID"))
        return
      }
      if( this.userInfo ){

        if(this.userInfo.bthBigType=='SS'){
          this.isShowCode = true
          this.typeStr = '标准展位'
        }else{
          this.typeStr = '特装展位'
        }
          
          
      }
      duration = (new Date().getTime() - this.userInfo.loginTime) / 1000 / 60 / 60
      // 登陆超过20小时后超时
      if (duration > 20) {
        this.$alert('超时，请重新登录', '', {
          confirmButtonText: '确定',
          callback: (action) => {
            localStorage.removeItem('userInfo')
            this.$router.push('/login?ExhID='+localStorage.getItem("ExhID"))
          }
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
#Sidebar {
  padding-top: 60px;
  height: auto;
  &:not(.el-menu--collapse) {
    width: 200px;
  }
}

@media screen and (max-width:540px){
  // #Sidebar {
  //   position: fixed;
  //   z-index: 10
  // }
}
</style>
